import type { CSSProperties } from 'react';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';

const Root = styled(Horizontal)`
  width: 100%;
  height: var(--half-unit);
  background-color: var(--c-nd-50);
  border-radius: var(--double-unit);
`;
const Filled = styled(Horizontal)`
  height: var(--half-unit);
  background-color: var(--color);
  border-radius: var(--double-unit);
  box-shadow: 0 0 4px 0 var(--color);
`;

type Props = { progress: number; color: string };
export const ProgressBar = ({ progress, color }: Props) => {
  return (
    <Root>
      <Filled
        style={{ width: `${progress}%`, '--color': color } as CSSProperties}
      />
    </Root>
  );
};
